module.exports = __webpack_public_path__ + "static/media/empty-advertisements.6dd847dd.svg";